import { Flex } from 'antd';
import clsx from 'clsx';
import Avatar from 'common/avatar/Avatar';
import IF from 'common/if/IF';
import Tooltip from 'common/antd-tooltip/Tooltip';
import { CircleTickIcon } from 'common/all-icons/custom-icons';
import { useIsMobile } from 'hooks';
import DisplayDateTime from 'utils/time/display_time';
import styles from './CompletedInfo.module.scss';

const CompletedInfo = ({
  completedBy,
  completedAt,
  byLabel = 'Completed by:',
  atLabel = 'Completed at:',
  gap = 8,
  avatarSize = 18,
  iconSize = 16,
  className = '',
  showIcon = true,
}) => {
  const isMobile = useIsMobile();
  const name = (typeof completedBy === 'string' ? completedBy : completedBy?.name) || '';
  const profilePicture = typeof completedBy === 'string' ? '' : completedBy?.profile_picture || '';
  const formattedDate = DisplayDateTime(completedAt);

  if (!name && !formattedDate) return null;

  return (
    <Flex
      vertical={isMobile}
      align={isMobile ? 'start' : 'center'}
      gap={gap}
      wrap="nowrap"
      className={clsx(styles.wrapper, className)}
    >
      <IF condition={name}>
        <Flex align="center" gap={6} className={clsx(styles.pill, styles.byPill)}>
          <span className={clsx('body-12-medium', styles.label)}>{byLabel}</span>
          <div style={{ size: avatarSize, flexShrink: 0 }}>
            <Avatar src={profilePicture} name={name} size={avatarSize} />
          </div>
          <Tooltip title={name}>
            <span className={clsx('body-12-semibold', styles.name)}>{name}</span>
          </Tooltip>
        </Flex>
      </IF>

      <IF condition={formattedDate}>
        <Flex align="center" gap={6} className={clsx(styles.pill, styles.atPill)}>
          <IF condition={showIcon}>
            <span className={styles.icon}>
              <CircleTickIcon width={iconSize} height={iconSize} />
            </span>
          </IF>
          <span className={clsx('body-12-medium', styles.label)}>{atLabel}</span>
          <span className={clsx('body-12-semibold', styles.date)}>{formattedDate}</span>
        </Flex>
      </IF>
    </Flex>
  );
};

export default CompletedInfo;
